module.exports = __webpack_public_path__ + "static/media/Team 19 LOGO - Ivy Xu.bf3e2c8b.jpg";